import { Component, Input } from '@angular/core';

import { LinkTabs } from './definitions/link-tabs.models';

@Component({
  selector: 'app-link-tabs',
  templateUrl: './link-tabs.component.html',
  styleUrls: ['./link-tabs.component.scss']
})
export class LinkTabsComponent {
  @Input() tabs: LinkTabs[];
}
